import * as Comlink from 'comlink';
import type { ParseApi } from './parse.worker';
import ParseWorker from './parse.worker?worker';

let remote: Comlink.Remote<ParseApi> | null = null;

/** The shared parse worker (created on first use). */
export function parser(): Comlink.Remote<ParseApi> {
  remote ??= Comlink.wrap<ParseApi>(new ParseWorker({ name: 'parse' }));
  return remote;
}
